import { Container, Box, Divider, Body } from '@hover/blueprint';
import React, { useState, useRef } from 'react';
import Slider, { Settings } from 'react-slick';
import { BETTER_WAY_TO_BUILD_CAROUSEL_DATA_MOBILE } from '../../../constants';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { CarouselArrow } from '../../common';

const PAGES_NUMBER = Array.from(Array(6).keys());

const setting: Settings = {
  dots: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: <CarouselArrow isPrevious />,
  nextArrow: <CarouselArrow />,
};

const MobileSlider: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const sliderRef = useRef<Slider>(null);

  const onSelectItem = (tabNumber: number) => {
    sliderRef?.current?.slickGoTo(tabNumber);
  };

  return (
    <Container d={{ base: 'block', desktop: 'none' }}>
      <Box justifyContent="space-between" position="relative" mt={500}>
        <Divider
          aria-hidden
          position="absolute"
          color="neutral.100"
          top="16px"
          my={0}
        />
        {PAGES_NUMBER.map(item => (
          <Box
            cursor="pointer"
            onClick={() => onSelectItem(item)}
            zIndex={10}
            key={item}
            w={300}
            h={300}
            borderRadius="50%"
            bg={selectedTab === item ? 'brandNavy.100' : 'neutral.100'}
            color={selectedTab === item ? 'black' : 'neutral.500'}
            alignItems="center"
            justifyContent="center"
            role="button"
            aria-label={`Go to Slide ${item + 1} of ${PAGES_NUMBER.length}`}
          >
            {item + 1}
          </Box>
        ))}
      </Box>
      <Box d="block" aria-live="polite">
        <Slider
          ref={sliderRef}
          {...setting}
          beforeChange={(_, newIndex) => setSelectedTab(newIndex)}
        >
          {BETTER_WAY_TO_BUILD_CAROUSEL_DATA_MOBILE.map(carouselItem => (
            <Box
              w="100%"
              mt="56px"
              alignItems="center"
              key={carouselItem.index}
              aria-hidden={carouselItem.index !== selectedTab}
              role="group"
              aria-labelledby="carousel-body"
            >
              <Box
                w="100%"
                flexDir="column"
                d="flex !important"
                id={carouselItem.index === selectedTab ? 'carousel-body' : ''}
              >
                {carouselItem.img}
                <Body mt={600} size={600} isSemiBold textAlign="center">
                  {carouselItem.body}
                </Body>
              </Box>
            </Box>
          ))}
        </Slider>
      </Box>
    </Container>
  );
};

export default MobileSlider;
